export default __webpack_public_path__ + "static/media/simple_pattern.5ea2ba5d.svg";